import { BlockTextAnimation } from '../gsap/_blockText.js';

const blocksTexts = document.querySelectorAll('.js-blocks-text');
if (blocksTexts) {
  blocksTexts.forEach(block => {
    let innerTexts = block.innerHTML;
    let textsArray = innerTexts.split('<br>'); // 改行で分割

    // div要素を作成
    let divElement = document.createElement('div');
    divElement.classList = 'p-blocks__wrap';

    textsArray.forEach(text => {
      // p要素を作成
      let pElement = document.createElement('p');
      let pWrapElement = document.createElement('div');
      let pDecoyElement = document.createElement('div');
      // ブロックのクラスから'js-blocks-text'を削除してクラスを付与
      let classes = Array.from(block.classList).filter(className => className !== 'js-blocks-text');
      pElement.classList.add(...classes);
      pElement.classList.add('p-blocks__text');
      pElement.innerHTML = text.trim(); // 余分な空白を削除して挿入

      pWrapElement.classList.add('p-blocks__text__wrap');
      pDecoyElement.classList.add('p-blocks__text__decoy');

      pWrapElement.appendChild(pElement);
      pWrapElement.appendChild(pDecoyElement);

      divElement.appendChild(pWrapElement); // p要素をdiv要素に追加
    });

    // 最初の"js-blocks-text"の親要素にdiv要素を挿入
    block.parentNode.insertBefore(divElement, block.nextSibling);
  });
  
  BlockTextAnimation();

}

